import { useDisclosure } from '@mantine/hooks'
import { PowderyMildewRow } from 'App/Map/PanelDetails/_utils/by-domain/powderyMildew/PowderyMildewRow'
import { TitleHelpIconButton } from 'App/Map/PanelDetails/SectionTitleBars/TitleHelpIconButton/TitleHelpIconButton'
import { ModalDrawer } from 'components/ModalDrawer/ModalDrawer'
import { translate } from 'i18n/i18n'
import { SharedSettings } from 'settings/SharedSettings'

const modalWidth = 650

export const GrapePowderyMildewTooltipModal = ({
  includeWesternUSAContent,
}: {
  includeWesternUSAContent: boolean
}) => {
  const [opened, { close, open }] = useDisclosure(false)

  const productCategoryMap = {
    [translate.phrases.banyanApp('Biologicals')]: translate.phrases.banyanApp('Sonata and Serenade Max'),
    [translate.phrases.banyanApp('SAR')]: translate.phrases.banyanApp(
      'Systemic acquired resistance products',
    ),
    [translate.phrases.banyanApp('Demethylation-inhibitors(DMI)')]:
      translate.phrases.banyanApp('Elite, Viticure and Rally'),
    [translate.phrases.banyanApp('Strobilurins & Quinolines')]: translate.phrases.banyanApp(
      'Flint, Sovran and Pristine',
    ),
  }

  return (
    <>
      <ModalDrawer
        size={modalWidth}
        opened={opened}
        onClose={close}
        title={translate.phrases.banyanApp('{{diseaseName}} Secondary Infection Risk Index', {
          diseaseName: translate.phrases.banyanApp('Grape Powdery Mildew'),
        })}
        zIndex={SharedSettings.DEFAULT_MODAL_DRAWER_Z_INDEX}
      >
        <div css={{ width: '100%', display: 'flex', justifyContent: 'left' }}>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              padding: 20,
              maxWidth: modalWidth,
              lineHeight: 1.3,
            }}
          >
            <PowderyMildewRow riskIndexLevel={'LOW'} includeWesternUSAContent={includeWesternUSAContent} />
            <PowderyMildewRow
              riskIndexLevel={'MODERATE'}
              includeWesternUSAContent={includeWesternUSAContent}
            />
            <PowderyMildewRow riskIndexLevel={'HIGH'} includeWesternUSAContent={includeWesternUSAContent} />

            {includeWesternUSAContent && (
              <div
                style={{
                  paddingTop: '30px',
                }}
              >
                {Object.entries(productCategoryMap).map(([key, value]) => {
                  return (
                    <div key={key}>
                      <strong>{`${key}:`}</strong>&nbsp;
                      <span>{value}</span>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      </ModalDrawer>
      <TitleHelpIconButton onClick={open} />
    </>
  )
}
